export const adminurls = [
  {
    url: "/dashboard",
    name: "Dashboard",
    icon: "fas fa-chart-line",
    subUrl: false,
  },
  {
    url: "/profile",
    name: "My Profile",
    icon: "far fa-user",
    subUrl: false,
  },
  {
    url: "/mylisting",
    name: "Delisted",
    icon: "far fa-list-alt",
    subUrl: false,
  },
  {
    url: "/add-listing",
    name: "Add Listing",
    icon: "fas fa-plus",
    subUrl: false,
  },
  {
    url: "change-password",
    name: "Change Password",
    icon: "fas fa-unlock-alt",
    subUrl: false,
  },
  {
    url: "leaving",
    name: "Logout",
    icon: "fas fa-sign-out-alt",
    subUrl: false,
  },
];
